export enum RecordingState {
  NotRecording = 'not-recording',
  Waiting = 'waiting',
  Recording = 'recording',
  Errored = 'errored',
}
